export const generateRoute = (
    path: string,
    element: React.Component,
): unknown => ({
    path,
    element,
});
